// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Icon/icon.sass
// module id = 344
// module chunks = 0